import * as React from 'react';
import { FormHelperText as MuiFormHelperText } from '@material-ui/core';

var FormHelperText = function FormHelperText(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      required = _ref.required;
  return /*#__PURE__*/React.createElement(MuiFormHelperText, {
    disabled: disabled,
    error: error,
    required: required
  }, children, label);
};

export default FormHelperText;

try {
  FormHelperText.__docgenInfo = {
    description: '',
    displayName: 'FormHelperText',
    methods: [],
    props: {
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the helper text should be displayed in a disabled state.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, helper text should be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the helper text should use required classes key.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map